import { Component, Input } from '@angular/core';
import { IObjectKey } from 'src/app/modules/shared/models/objects';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { PREV_anticipazioni_form_keys, PREV_datiContributi_form_keys, PREV_datiContributiNonDedotti_form_keys, PREV_datiContributiPremio_form_keys, PREV_fiscal_data_form_keys, PREV_sintesiDatiContributiNonDedotti_form_keys } from '../../pages/policy-detail/policy-detail.constants';
import { IPolicyDetail } from 'src/app/modules/shared/models/policy.model';

@Component({
  selector: 'app-policy-scheda-fiscalita',
  templateUrl: './policy-scheda-fiscalita.component.html',
  styleUrl: './policy-scheda-fiscalita.component.scss'
})
export class PolicySchedaFiscalitaComponent {
  @Input() detail: IPolicyDetail;

  ngOnInit() {
    const PREV_dynamic_anticipazioni_form_keys: IObjectKey[] = [
      {
        label: `${this.detail?.summary?.productDescription} Anticipazioni`,
        key: 'intesaFurtherDetails.uni30.fiscalData.anticipazioni.anticipazioni.anticipazioniPrevid',
        pipe: {
          key: 'currency',
          value: 'EUR',
        },
      },
      {
        label: `${this.detail?.summary?.productDescription} Anticipazioni al 30%`,
        key: 'intesaFurtherDetails.uni30.fiscalData.anticipazioni.anticipazioni.anticipazioniPrevidAl30',
        pipe: {
          key: 'currency',
          value: 'EUR',
        },
      },
      {
        label: `${this.detail?.summary?.productDescription} Riscatti Parziali`,
        key: 'intesaFurtherDetails.uni30.fiscalData.anticipazioni.anticipazioni.riscattiParziali',
        pipe: {
          key: 'currency',
          value: 'EUR',
        },
      },
    ]
    this.keysGroup = [PREV_dynamic_anticipazioni_form_keys, PREV_anticipazioni_form_keys, PREV_fiscal_data_form_keys,
      PREV_sintesiDatiContributiNonDedotti_form_keys, PREV_datiContributi_form_keys, PREV_datiContributiNonDedotti_form_keys, PREV_datiContributiPremio_form_keys]

  }

  getValueByPath(detail: any, item: IObjectKey): string {
    const value = CommonUtils.getValueByPath(detail, item);
    return value;
  }

  getTableList(item: IObjectKey): any[] {
    return CommonUtils.checkAndGet(
      this.detail,
      item.key,
      null
    );
  }

  keysGroup: IObjectKey[][] = []

}
